/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EPrintingQueueStatus {
    GENERATING = 'GENERATING',
    DONE = 'DONE',
    ERROR = 'ERROR',
    CANCELLED = 'CANCELLED',
    WAITING = 'WAITING'
}


export function EPrintingQueueStatusFromJSON(json: any): EPrintingQueueStatus {
    return EPrintingQueueStatusFromJSONTyped(json, false);
}

export function EPrintingQueueStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EPrintingQueueStatus {
    return json as EPrintingQueueStatus;
}

export function EPrintingQueueStatusToJSON(value?: EPrintingQueueStatus | null): any {
    return value as any;
}

